import { Stack, Text, ThemeOverride } from "@certn/cascadia";
import { useTranslation } from "react-i18next";
import { Avatar, Card, Divider, Icon } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useAuth } from "@certn/auth";
import { parseName } from "@certn/utils";
import { useBrandingContext } from "../BrandingContext";
import { NavLogo } from "@certn/cascadia-react/components/navigation/navigation-top/NavLogo";
import { darkColors, lightColors } from "@certn/cascadia-tokens";

export function MobileMenu() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { processedBrandingAssets } = useBrandingContext();

  return (
    <Stack orientation="vertical" gap="space-5" className={styles.container}>
      <Text style="global/heading-medium">{t("Sample")}</Text>
      <ThemeOverride theme="light">
        <Stack orientation="vertical" gap="space-5">
          <Text style="global/heading-medium" className={styles.heading}>
            {t("Light mode")}
          </Text>
          <Card className={styles.lightMode}>
            <Stack orientation="vertical" gap="space-0">
              <Stack
                justify="space-between"
                orientation="horizontal"
                className={styles.mode}
              >
                <div className={styles.logoContainer}>
                  <NavLogo
                    logoUrl={processedBrandingAssets?.org_logo_url}
                    darkLogoUrl={
                      processedBrandingAssets?.org_logo_url_dark_mode
                    }
                    orgIconUrl={processedBrandingAssets?.org_icon_url}
                    orgIconUrlDarkMode={
                      processedBrandingAssets?.org_icon_url_dark_mode
                    }
                    type="logo"
                  />
                </div>
                <Stack orientation="horizontal" gap="space-3">
                  <Icon name="add" color="icon-accent-tofino" />
                  <Avatar name={parseName(user?.name)} size="medium" />
                  <Icon name="menu" color="icon-accent-tofino" />
                </Stack>
              </Stack>
              <Divider />
              <Stack className={styles.empty} />
            </Stack>
          </Card>
        </Stack>
      </ThemeOverride>
      <ThemeOverride theme="dark">
        <Stack orientation="vertical" gap="space-5">
          <Text style="global/heading-medium" className={styles.heading}>
            {t("Dark mode")}
          </Text>
          <Card className={css(styles.darkMode)}>
            <Stack orientation="vertical" gap="space-0">
              <Stack
                justify="space-between"
                orientation="horizontal"
                className={styles.mode}
              >
                <div className={styles.logoContainer}>
                  <NavLogo
                    logoUrl={processedBrandingAssets?.org_logo_url}
                    darkLogoUrl={
                      processedBrandingAssets?.org_logo_url_dark_mode
                    }
                    orgIconUrl={processedBrandingAssets?.org_icon_url}
                    orgIconUrlDarkMode={
                      processedBrandingAssets?.org_icon_url_dark_mode
                    }
                    type="logo"
                  />
                </div>
                <Stack orientation="horizontal" gap="space-3">
                  <Icon name="add" color="icon-accent-tofino" />
                  <Avatar name={parseName(user?.name)} size="medium" />
                  <Icon name="menu" color="icon-accent-tofino" />
                </Stack>
              </Stack>
              <Divider />
              <Stack className={styles.empty} />
            </Stack>
          </Card>
        </Stack>
      </ThemeOverride>
    </Stack>
  );
}

const styles = {
  container: css({
    paddingBottom: "var(--space-5)",
    paddingLeft: "var(--space-3)",
    paddingRight: "var(--space-3)",
  }),
  logoContainer: css({
    width: "fit-content",
    maxWidth: "200px",
    "& img, & svg": {
      width: "auto !important",
      maxWidth: "200px",
      height: "30px",
    },
  }),
  mode: css({
    paddingTop: "var(--space-4)",
    paddingBottom: "var(--space-4)",
    paddingLeft: "var(--space-8)",
    paddingRight: "var(--space-8)",
  }),
  heading: css({
    paddingLeft: "var(--space-7)",
    paddingRight: "var(--space-7)",
  }),
  darkMode: css({
    backgroundColor: `${darkColors["surface-base"]} !important`,
  }),
  lightMode: css({
    backgroundColor: `${lightColors["surface-base"]} !important`,
  }),
  empty: css({
    height: "50px",
  }),
};
